import { confidenceDevStorageKey } from '../confidenceDev';
import { isDevToggleEnabled, setDevToggleEnabled } from '../toggles';

export const FLAG_TOOLING_STORAGE_KEY = confidenceDevStorageKey('flag-tooling');

export const isFlagToolingEnabled = (): boolean =>
  process.env.NODE_ENV === 'development' ||
  isDevToggleEnabled(FLAG_TOOLING_STORAGE_KEY);

export const enableFlagTooling = (): void =>
  setDevToggleEnabled(FLAG_TOOLING_STORAGE_KEY, true);
